<template>
   <div class="update-assessment-element container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row margin-left-1Point5Perc">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
                      {{getCurrentlySelectedCourseObj.CourseTitle}}
                </div>    
                <div class="col-md-5 col-lg-5">
                  <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="udpateCloseCreateElementOverlay($event,false)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
                  <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
                      {{lessonObj.Title}}
                  </div>    
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  <!-- Index -->
                  Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="RDTitleValue" :maxlength="maxLength">
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Duration
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                        <input type="text" class="form-control" v-model="AssessmentDurationValue" placeholder="MM:SS">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <!-- ss audio end -->
              <div class="row vertical-align">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Assessment
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="assessmentIdValue" disabled>
                        <option value=-1 disabled>Select</option>
                        <option v-for="assessmentObj in getAssessmentList" v-bind:key="assessmentObj.AssessmentId" v-bind:value="assessmentObj.AssessmentId">
                          {{ assessmentObj.AssessmentTitle + ' [' + assessmentObj.AssessmentSubTitle + ']'}}
                        </option>
                      </select>
                    </div>    
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px"> 
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="checkbox">
                      <label><input type="checkbox" v-model="AssessmentIncludeInProgress">Include In Progress</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left font-size-12px">
                      <b>Type:</b> {{assessmentTypeNameValue}}
                    </div>    
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px"> 
                </div>
                <div class="col-md-4 col-lg-4">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Content
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <tinymce id="d1" v-model="AssessmentContentValue"></tinymce>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="(this.currSelectedAssessmentObj !== undefined && this.currSelectedAssessmentObj !== null) && this.currSelectedAssessmentObj.AssessmentType === constants.AssessmentType.Personalization">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                    <div class="col-sm-12" v-if="assessmentMCQElementList.length > 0" >
                      <update-assessment-mcq-question-list :lessonObj="lessonObj" :parentElementObj="ElementObj" v-for="(mcqObj, index) in assessmentMCQElementList" :key="mcqObj.ElementId" :currIndex="index" :mcqAssessmentObj="mcqObj" :courseJourneyList="courseJourneyList"></update-assessment-mcq-question-list>
                    </div>
                    <div class="col-sm-12" v-else>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="UpdateAssessmentElement">Update Assessment</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
      </div> 
      <loader></loader>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div> 
</template>
<script>
import { constants } from '@/utils/constants'
// import jdata from '@/server-util/update-assessment-service'
import AlertBox from '@/components/AlertOverlay'
import { VueEditor } from 'vue2-quill-editor'
import { elementService } from '@/server-util/element-service'
import Loader from '@/components/dashboard/Loader'
import tinymce from 'vue-tinymce-editor'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { assessmentService } from '@/server-util/assessment-service'
import { moduleService } from '@/server-util/module-service'
import updateAssessmentMCQQuestionList from '@/components/updateAssessmentMCQQuestionList'
import filter from 'lodash/filter'
import forEach from 'lodash/forEach'
import find from 'lodash/find'
export default {
  props: ['lessonObj', 'ElementObj'],
  name: 'update-assessment-element',
  created () {
    this.getAssessmentListFromServer()
    this.setDefaultValues()
    this.setAssessmentTypeName()
  },
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      elementObj: {
        ModuleId: '',
        Title: '',
        AudioUrl: null,
        AudioEntryId: '',
        AudioFlavorId: '',
        Duration: '',
        Type: 14,
        VideoUrl: null,
        KalturaEntryId: null,
        KalturaFlavorId: null,
        Content: '',
        Index: null,
        RDType: -1,
        IncludeInProgress: false,
        LinkText: null,
        FileUrl: null,
        ElemChallenge: null,
        AssessmentId: '',
        AssessmentMetaData: []
      },
      assessmentMCQElementList: [],
      courseJourneyList: [],
      maxLength: constants.Element_Title_Step_Max_Length,
      assessmentTypeName: '',
      currSelectedAssessmentObj: null
    }
  },
  components: {
    'alert-box': AlertBox,
    VueEditor,
    'loader': Loader,
    'tinymce': tinymce,
    'update-assessment-mcq-question-list': updateAssessmentMCQQuestionList
  },
  methods: {
    setAssessmentTypeName: function () {
      this.currSelectedAssessmentObj = find(this.getAssessmentList, (obj) => {
        return obj.AssessmentId === this.elementObj.AssessmentId
      })
      if (this.currSelectedAssessmentObj != null) {
        switch (this.currSelectedAssessmentObj.AssessmentType) {
          default:
          case constants.AssessmentType.Personalization:
            this.assessmentTypeName = 'Personalization'
            break
          case constants.AssessmentType.PrePost:
            this.assessmentTypeName = 'Pre-Post'
            break
          case constants.AssessmentType.StandAlone:
            this.assessmentTypeName = 'Stand Alone'
            break
        }
      }
    },
    getAssociatedMCQElements () {
      this.$store.state.isLoading = true
      var storeObj = this.$store
      var _this = this
      assessmentService
        .getAllAssessmentElementList(
          storeObj.state.access_token,
          this.ElementObj.AssessmentId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            _this.assessmentMCQElementList = filter(responseObj.data, (obj) => {
              return parseInt(obj.Type) === 3
            })
            _this.$store.state.assessmentElementListToPost = []
            forEach(_this.assessmentMCQElementList, (obj) => {
              var objToPush = {
                MCQElementId: obj.ElementId,
                ElementListForPersonalization: this.addSelectedElementIds(obj.ElementId)
              }
              this.$store.state.assessmentElementListToPost.push(objToPush)
            })
            _this.$store.state.isLoading = false
            _this.getCurrentCourseJourneyScreen()
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
          }
          _this.$store.state.isLoading = false
        }, errorObj => {
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    addSelectedElementIds: function (MCQElementId) {
      var selectedStepsArr = []
      if (this.elementObj.AssessmentMetaData !== undefined && this.elementObj.AssessmentMetaData !== 'undefined' && this.elementObj.AssessmentMetaData !== null && this.elementObj.AssessmentMetaData !== 'null' && this.elementObj.AssessmentMetaData !== '') {
        for (var i = 0; i < this.elementObj.AssessmentMetaData.length; i++) {
          var parentMCQObj = this.elementObj.AssessmentMetaData[i]
          if (parentMCQObj.MCQElementId === MCQElementId) {
            forEach(parentMCQObj.ElementListForPersonalization, (obj) => {
              selectedStepsArr.push(obj.ElementId)
            })
          }
        }
      }
      console.log('Found ' + selectedStepsArr.length + ' records for ' + MCQElementId)
      return selectedStepsArr
    },
    getCurrentCourseJourneyScreen: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
      ) {
        _this.$store.state.isLoading = true
        moduleService
          .getCourseJourneyDataForAssesment(
            storeObj.state.access_token,
            this.ElementObj.ElementId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.courseJourneyList = responseObj.data
              _this.$store.state.isLoading = false
            } else {
              if (_this.$store.state.isLoading === true) {
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING ASSESSMENT LIST'
        )
      }
    },
    getAssessmentListFromServer: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        var listPresent = false
        // AK: Check whether list is already present or not?
        if (storeObj.state.assessmentList.length === 0) {
          _this.$store.state.isLoading = true
          listPresent = false
        } else {
          _this.getAssociatedMCQElements()
          _this.setAssessmentTypeName()
          listPresent = true
        }
        assessmentService
          .getAllAssessmentList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.assessmentList = responseObj.data.AssessmentList
              storeObj.state.recAssessmentList = responseObj.data.CoursemasterList
              _this.$store.state.isLoading = false
              if (!listPresent) {
                _this.setAssessmentTypeName()
                _this.getAssociatedMCQElements()
              }
            } else {
              if (_this.$store.state.isLoading === true) {
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING ASSESSMENT LIST'
        )
      }
    },
    udpateCloseCreateElementOverlay: function (event) {
      this.$emit('closeUpdateAssessmentOverlay', false)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    bindAssessmentMetaDataObj: function () {
      this.elementObj.AssessmentMetaData = []
      forEach(this.getAssessmentElementListToPost, (parentMCQObj) => {
        var mainMCQObj = {
          MCQElementId: parentMCQObj.MCQElementId,
          ElementListForPersonalization: []
        }
        forEach(parentMCQObj.ElementListForPersonalization, (selectedElementId) => {
          var objToPush = {
            ElementId: selectedElementId,
            CourseMasterId: this.getCurrentlySelectedCourseObj.CourseMasterId,
            ModuleId: this.getCurrentElementModuleId(selectedElementId)
          }
          mainMCQObj.ElementListForPersonalization.push(objToPush)
        })
        this.elementObj.AssessmentMetaData.push(mainMCQObj)
      })
    },
    getCurrentElementModuleId: function (elementIdToCheck) {
      var moduleIdToReturn = null
      forEach(this.courseJourneyList, (moduleObj) => {
        forEach(moduleObj.ElementObj, (elementObj) => {
          if (elementObj.ElementId === elementIdToCheck) {
            moduleIdToReturn = moduleObj.ModuleId
          }
        })
      })
      return moduleIdToReturn
    },
    UpdateAssessmentElement: function (event) {
      this.bindAssessmentMetaDataObj()
      console.log('this.elementObj.AssessmentMetaData: ' + JSON.stringify(this.elementObj.AssessmentMetaData))
      if (this.validateRequiredFieldBeforeSubmit()) {
        var _this = this
        var storeObj = this.$store
        if (
          (this.elementObj.ModuleId !== undefined &&
          this.elementObj.ModuleId !== '' &&
          this.elementObj.ModuleId !== undefined) &&
          (this.elementObj.ElementId !== undefined &&
          this.elementObj.ElementId !== '' &&
          this.elementObj.ElementId !== undefined)
        ) {
          // AK: Start showing spinner
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
          const orgContent = dmAdminUtils.removeTFromUrls(_this.elementObj.Content)
          _this.elementObj.Content = orgContent
          // AK: Format added content text before post
          // _this.elementObj.Content = _this.elementObj.Content.replace(/<p>/gm, '<p style=\'margin: 0px\'>')
          elementService
            .updateAssessmentElement(storeObj.state.access_token, _this.elementObj)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                // AK: Close RD update Overlay
                _this.$emit('closeUpdateAssessmentOverlay', false)
                // AK: Refresh Element List by emitting event (LessonListCreateElement option)
                _this.$emit('refreshElementList', true)
              } else {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected ModuleId or ElementID is NULL hence declined UPDATE ASSESSMENT ELEMENT OPERATION'
          )
        }
      }
    },
    setDefaultValues: function () {
      this.$store.state.assessmentElementListToPost = []
      this.elementObj.ModuleId = this.ElementObj.ModuleId
      this.elementObj.ElementId = this.ElementObj.ElementId
      this.elementObj.Index = this.ElementObj.Index
      this.elementObj.Title = this.ElementObj.Title
      this.elementObj.Duration = this.ElementObj.Duration
      this.elementObj.RDType = this.ElementObj.RDType
      this.elementObj.IncludeInProgress = this.ElementObj.IncludeInProgress
      this.elementObj.AssessmentId = this.ElementObj.AssessmentId
      this.elementObj.AudioUrl = this.ElementObj.AudioUrl
      this.elementObj.AssessmentMetaData = this.ElementObj.AssessmentMetaData
      if (this.ElementObj.AudioUrl !== null && this.ElementObj.AudioUrl !== 'null' && this.ElementObj.AudioUrl !== undefined) {
        var audioObj = dmAdminUtils.getEntryAndFlavourIds(this.ElementObj.AudioUrl)
        this.elementObj.AudioEntryId = audioObj.EntryId
        this.elementObj.AudioFlavorId = audioObj.FlavorId
      } else {
        this.elementObj.AudioEntryId = ''
        this.elementObj.AudioFlavorId = ''
      }
      setTimeout(() => {
        this.elementObj.Content = dmAdminUtils.updateUrls(this.ElementObj.Content)
      }, 500)
    },
    validateRequiredFieldBeforeSubmit: function () {
      var regex = /^(?:([0-5]?\d):)?([0-5]?\d)$/g
      if (this.RDTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        this.elementObj.Title = this.ElementObj.Title
        return false
      } else if ((this.AssessmentDurationValue.trim().length !== 0 && this.AssessmentDurationValue.indexOf(':') === -1)) {
        this.showAlertDialog = true
        this.errorMsg = 'Duration format should be MM:SS.'
        return false
      } else if (this.elementObj.IncludeInProgress && this.elementObj.Duration.trim().length > 0 && !regex.test(this.elementObj.Duration)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter a valid duration.'
        return false
      } else if (this.stripHtml(this.AssessmentContentValue).trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Content can\'t be empty.'
        this.elementObj.Content = this.ElementObj.Content
        return false
      } else if ((this.currSelectedAssessmentObj.AssessmentType === constants.AssessmentType.Personalization) && this.isStepSelectedForAllMCQOptions()) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one step from each mcq.'
        this.elementObj.RDType = this.ElementObj.RDType
        return false
      }
      return true
    },
    isStepSelectedForAllMCQOptions: function () {
      var notSelected = false
      for (var i = 0; i < this.elementObj.AssessmentMetaData.length; i++) {
        var personalizationList = this.elementObj.AssessmentMetaData[i].ElementListForPersonalization
        if (personalizationList.length === 0) {
          notSelected = true
          break
        }
      }
      return notSelected
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    }
  },
  computed: {
    assessmentTypeNameValue: {
      get: function () {
        return this.assessmentTypeName
      }
    },
    assessmentIdValue: {
      get: function () {
        return this.elementObj.AssessmentId
      },
      set: function (newValue) {
        this.elementObj.AssessmentId = newValue
      }
    },
    getAssessmentList: {
      get: function () {
        return this.$store.state.assessmentList
      }
    },
    AudioUrlValue: {
      get: function () {
        return this.ElementObj.AudioUrl
      }
    },
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    RDTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    AudioEntryIdValue: {
      get: function () {
        return this.elementObj.AudioEntryId
      },
      set: function (newValue) {
        this.elementObj.AudioEntryId = newValue
      }
    },
    AudioFlavourIdValue: {
      get: function () {
        return this.elementObj.AudioFlavorId
      },
      set: function (newValue) {
        this.elementObj.AudioFlavorId = newValue
      }
    },
    RDIndexValue: {
      get: function () {
        return this.elementObj.Index
      },
      set: function (newValue) {
        if (newValue.trim() !== '') {
          var isNonNumeric = /[^$,.\d]/
          var nonNumericResult = newValue.match(isNonNumeric)
          if (!nonNumericResult) {
            if (parseInt(newValue) >= 1000) {
              this.errorMsg = 'Index should be less than 1000.'
              this.showAlertDialog = true
              this.elementObj.Index = this.ElementObj.Index
            } else {
              this.elementObj.Index = parseInt(newValue)
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Index must be a positive numeric value.'
            this.elementObj.Index = this.ElementObj.Index
          }
        } else {
          this.elementObj.Index = null
        }
      }
    },
    AssessmentDurationValue: {
      get: function () {
        return this.elementObj.Duration
      },
      set: function (newValue) {
        this.elementObj.Duration = newValue
      }
    },
    RDTypeValue: {
      get: function () {
        return this.elementObj.RDType
      },
      set: function (newValue) {
        if (newValue !== '') {
          this.elementObj.RDType = parseInt(newValue)
        } else {
          this.elementObj.RDType = null
        }
      }
    },
    AssessmentContentValue: {
      get: function () {
        return this.elementObj.Content
      },
      set: function (newValue) {
        this.elementObj.Content = newValue
      }
    },
    AssessmentIncludeInProgress: {
      get: function () {
        return this.elementObj.IncludeInProgress
      },
      set: function (newValue) {
        this.elementObj.IncludeInProgress = newValue
      }
    },
    getAssessmentElementListToPost: {
      get: function () {
        return this.$store.state.assessmentElementListToPost
      },
      set: function (newValue) {
        this.$store.state.assessmentElementListToPost = newValue
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.font-size-12px {
  font-size: 12px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.border-red {
  border: 1px solid red;
}
.audio-width {
  width: -webkit-fill-available;
}
.padding-left-right-20px {
  padding-left: 20px;
  padding-right: 20px;
}

.mcq-area{
  display: block;

  height: 100px;
 
  width: 100%;
  padding: 20%;
}

.padding-left12per{
  padding-left: 20%;
}

.lession-container{
  width: 100%;
  /* border: 2px solid black; */
 
}

.mcq-heading{
  margin: 0;
  text-align: start;
  padding-left: 12%;

}

.element-li{

    margin: 0;
  text-align: start;


}

.element-container{
  margin-left: 12%;
  list-style: none;
}
</style>


// WEBPACK FOOTER //
// src/components/UpdateAssessmentElement.vue